<template>
	<div class="goods">
		<!-- 综合列表 -->
		<van-row class="dropdown">
			<van-dropdown-menu active-color="#f1452f" :class="{active : flag==1}">
				<van-dropdown-item v-model="value" :options="option" @change="changes" />
			</van-dropdown-menu>

			<van-col span="5">
				<div class="esp">
					<span>价格</span>
					<img v-if="flag==5" alt="">
					<img v-else-if="flag==6" src="../../assets/down.png" alt="">
					<img v-else src="../../assets/default.png" alt="">
				</div>
			</van-col>
			<van-col span="4" @click="toggTab(3)" :class="{active : flag==3}">
				<span class="esp">新品</span>
			</van-col>
			<van-col span="5" @click="toggTab(7)" :class="{active : flag==7}">
				<span class="esp">销量</span>
			</van-col>
		</van-row>
		<!--商品列表 -->
		<van-list v-model="loading" :offset="offset" :finished="finished" :immediate-check="immediate_check" finished-text="我是有底线的"
		 @load="onLoad">
			<ul class="left-waterfall" ref="left">
				<li class="item" v-for="(item, index) in leftItems" @click="setParams(item.id)">
					<img :src="item.image | handleUrl" alt="">
					<div class="main">
						<p>{{item.title}}</p>
						<div class="vangrid-right">
							<span class="f1452f">
								<span>租金</span>
								<span class="font-5">￥{{item.price}}</span><span>/月</span><span class="qizi">起</span>
							</span>
							<van-icon name="shopping-cart-o" size="14px" color="#fff" />
						</div>
						<div class="vangrid-bottom">
							<div class="gonswe">
								<span v-if="item.goods_work == 7">工期7-10天</span>
								<span v-if="item.goods_work == 15">工期15-20天</span>
								<span v-if="item.goods_work == 30">工期30-40天</span>
								<van-rate size="0.7rem" color="#F1452F" gutter="1px" v-model="item.hot_num" readonly />
							</div>
						</div>
					</div>
				</li>
			</ul>
			<ul class="right-waterfall" ref="right">
				<li class="item" v-for="(item, index) in rightItems" @click="setParams(item.id)">
					<img :src="item.image | handleUrl" alt="">
					<div class="main">
						<p>{{item.title}}</p>
						<div class="vangrid-right">
							<span class="f1452f">
								<span>租金</span>
								<span class="font-5">￥{{item.price}}</span><span>/月</span><span class="qizi">起</span>
							</span>
							<van-icon name="shopping-cart-o" size="14px" color="#fff" />
						</div>
						<div class="vangrid-bottom">
							<div class="gonswe">
								<span v-if="item.goods_work == 7">工期7-10天</span>
								<span v-if="item.goods_work == 15">工期15-20天</span>
								<span v-if="item.goods_work == 30">工期30-40天</span>
								<!-- <span>热度：</span> -->
								<van-rate size="0.7rem" color="#F1452F" gutter="1px" v-model="item.hot_num" readonly />
							</div>
						</div>
					</div>
				</li>
			</ul>
			<div style="clear:both"></div>
		</van-list>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				finished: false,
				offset: 0,
				immediate_check: false,
				flag: 1, //导航条件
				show: false,
				//商品列表
				goods: [],
				leftItems: [],
				rightItems: [],
				brand: [],
				page: 1,
				value: '',
				option: [],
				cat_id: ''
			}
		},
		mounted() {
			this.updateWaterfall();
		},
		created() {
			this.getData();
		},
		methods: {
			updateWaterfall() {
				// const leftHeight = this.$refs.left.clientHeight
				// const rightHeight = this.$refs.right.clientHeight
				const leftHeight = this.leftItems.length
				const rightHeight = this.rightItems.length
				let item = this.goods.shift();
				if (item == null) {
					return
				}
				if (leftHeight <= rightHeight) {
					this.leftItems.push(item)
				} else {
					this.rightItems.push(item)
				}
				this.$nextTick(function() {
					this.updateWaterfall()
				})
			},
			//价格切换
			toggle() {
				if (this.flag != 5) {
					this.flag = 5
				} else if (this.flag == 5) {
					this.flag = 6
				}
				this.goodsShow();
			},
			//获取id列表
			getData() {
				//分类
				this.$axios.post(baseUrl + '/mobile/Category/goodsCategory').then((res) => {
					if (res.data.code == 2) {
						var arr = [{
							text: '分类',
							value: ''
						}, ];
						for (let i in res.data.data.category) {
							arr.push({
								text: res.data.data.category[i].title,
								value: res.data.data.category[i].id
							})
						}
						this.option = arr;
					}
				}).catch(function(err) {
					console.log(err);
				});
			},
			//切换导航数据
			goodsShow() {
				this.finished = false;
				this.page = 1;
				this.leftItems = [];
				this.rightItems = [];
			},
			// 异步更新数据
			onLoad() {
				//异步更新数据
				this.$axios.post(baseUrl + '/mobile/Goods/goodsShow', {
					brand_id: this.$route.query.id,
					page: this.page,
					limit: 10,
					order: this.flag,
					cat_id: this.cat_id,
					category_id: 1
				}).then((res) => {
					if (res.data.code == 2) {
						this.page++;
						setTimeout(() => {
							for (var i in res.data.data) {
								this.goods.push(res.data.data[i])
							}
							// 加载状态结束
							this.loading = false;
							this.updateWaterfall()
						}, 1000)
					} else {
						this.loading = false;
						this.finished = true;
					}
				}).catch((err) => {
					console.log(err);
				});
			},
			//条件切换
			toggTab(fa) {
				this.flag = fa;
				this.goodsShow();
			},
			//选项改变
			changes(value) {
				this.flag = 1;
				this.cat_id = value;
				this.goodsShow();
			},
			//跳转详情页
			setParams(em) {
				this.$router.push({
					path: '/Detail',
					query: {
						id: em
					}
				})
			}
		}
	}
</script>

<style scoped>
	@import 'goods.css';

	.gonswe span {
		position: relative;

	}

	.gonswe {
		margin-bottom: 0.3rem;
		color: #28334b;
		display: flex;
		justify-content: space-between;
	}

	.goods .dropdown {
		width: 100%;
		background: #fff;
		z-index: 666;
		position: relative;
	}

	.goods .van-list .main .font-5[data-v-80a9aa06] {
		font-size: 1rem;
		margin-right: 0rem;
	}

	.goods .van-list {
		padding: 0.5rem 0.5rem 0 0.5rem;
		text-align: left;
		box-sizing: border-box;
	}

	.yingcang {
		overflow: hidden;
	}

	.vangrid-bottom>>>.van-rate--readonly {
		margin-top: 0.2rem;
	}

	.yueqilai {
		color: #F1452F;
		transform: scale(0.8);
	}
	
</style>



// WEBPACK FOOTER //
// src/components/goods/goods.vue